import React, { useState, useEffect } from 'react'
import Layout from '../Home'
import KnowledgeVideosTable from '../../components/KnowledgeVideosTable'
import { message } from 'antd'
import * as knowledgeVideosServices from '../../apiServices/knowledgeVideosServices'

const KnowledgeVideos = (props) => {
    const [dataSource, setDataSource] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        fetchVideos()
    }, [])

    const fetchVideos = async () => {
        setLoading(true)
        try {
            const response = await knowledgeVideosServices.getVideos()
            const data = Array.isArray(response.data) ? response.data : (Array.isArray(response) ? response : [])
            setDataSource(data)
        } catch (error) {
            console.error('Error fetching videos:', error)
            message.error('ไม่สามารถโหลดข้อมูลคลิปวิดีโอได้')
        } finally {
            setLoading(false)
        }
    }

    const createVideo = async (data) => {
        try {
            await knowledgeVideosServices.createVideo(data)
            message.success('เพิ่มคลิปวิดีโอสำเร็จ')
            await fetchVideos()
            return true
        } catch (error) {
            console.error('Error creating video:', error)
            message.error('ไม่สามารถเพิ่มคลิปวิดีโอได้')
            return false
        }
    }

    const updateVideo = async (id, data) => {
        try {
            await knowledgeVideosServices.updateVideo(id, data)
            message.success('อัปเดตคลิปวิดีโอสำเร็จ')
            await fetchVideos()
            return true
        } catch (error) {
            console.error('Error updating video:', error)
            message.error('ไม่สามารถอัปเดตคลิปวิดีโอได้')
            return false
        }
    }

    const deleteVideo = async (id) => {
        try {
            await knowledgeVideosServices.deleteVideo(id)
            message.success('ลบคลิปวิดีโอสำเร็จ')
            await fetchVideos()
            return true
        } catch (error) {
            console.error('Error deleting video:', error)
            message.error('ไม่สามารถลบคลิปวิดีโอได้')
            return false
        }
    }

    return (
        <Layout
            {...props}
            render={(
                renderProps, //eslint-disable-line
            ) => (
                <KnowledgeVideosTable
                    {...renderProps}
                    dataSource={dataSource}
                    loading={loading}
                    onCreate={createVideo}
                    onUpdate={updateVideo}
                    onDelete={deleteVideo}
                    onRefresh={fetchVideos}
                    style={{ width: '100%' }}
                />
            )}
        />
    )
}

export default KnowledgeVideos

